(function () {
  var root = document.querySelector('[data-th-home-discount]');

  if (!root || !window.localStorage) return;

  var config = window.THHomeDiscountPopupConfig || {};
  var panel = root.querySelector('[data-th-home-discount-panel]');
  var successPanel = root.querySelector('[data-th-home-discount-success]');
  var shell = root.querySelector('[data-th-home-discount-shell]');
  var overlay = root.querySelector('[data-th-home-discount-overlay]');
  var bubble = root.querySelector('[data-th-home-discount-bubble]');
  var bubbleText = root.querySelector('[data-th-home-discount-bubble-text]');
  var form = root.querySelector('[data-th-home-discount-form]');
  var emailInput = root.querySelector('#th-home-discount-email');
  var submitButton = root.querySelector('[data-th-home-discount-submit]');
  var message = root.querySelector('[data-th-home-discount-message]');
  var closeButton = root.querySelector('[data-th-home-discount-close]');
  var minimizeButton = root.querySelector('[data-th-home-discount-minimize]');
  var continueButton = root.querySelector('[data-th-home-discount-continue]');

  var stateKey = config.stateKey || 'th-home-discount-popup-state';
  var successKey = config.successKey || 'th-home-discount-popup-pending-success';
  var emailKey = config.emailKey || 'th-home-discount-popup-email';
  var usedEmailKey = 'th-home-discount-used-email';
  var initialDelayMs = window.innerWidth <= 749 ? 12000 : 8000;
  var discountValue = (config.discountValue || '10%').trim();
  var discountLabel = discountValue + ' de descuento';
  var configuredCode = (config.discountCode || '').trim();
  var hasDiscountCode = configuredCode !== '' && configuredCode !== 'CAMBIAR_CODIGO_DESCUENTO';
  var defaultRedirectPath = config.redirectPath || '/';
  var backgroundSubmitFrameName = 'th-home-discount-submit-frame';

  function setStorage(key, value) {
    window.localStorage.setItem(key, value);
  }

  function getStorage(key) {
    return window.localStorage.getItem(key);
  }

  function showError(text) {
    if (!message) return;
    message.textContent = text || '';
  }

  function focusEmailInput() {
    if (!emailInput || typeof emailInput.focus !== 'function') return;

    try {
      emailInput.focus({ preventScroll: true });
    } catch (error) {
      emailInput.focus();
    }
  }

  function setLoading(isLoading) {
    if (!submitButton) return;

    submitButton.disabled = isLoading;
    submitButton.textContent = isLoading ? 'Aplicando ' + discountValue + '...' : 'Quiero mi ' + discountLabel;
  }

  function setBubbleLabel(state) {
    if (!bubbleText) return;

    bubbleText.textContent = state === 'applied' ? discountValue + ' activo' : 'Abrir ' + discountLabel;
  }

  function syncState(state) {
    root.hidden = false;
    root.dataset.state = state;

    var showModal = state === 'open' || state === 'success';
    var showSuccess = state === 'success';
    var showBubble = state === 'minimized' || state === 'applied';

    shell.hidden = !showModal;
    overlay.hidden = !showModal;
    panel.hidden = state !== 'open';
    successPanel.hidden = !showSuccess;
    bubble.hidden = !showBubble;

    if (showModal) {
      root.style.pointerEvents = 'auto';
    } else {
      root.style.pointerEvents = 'none';
    }

    setBubbleLabel(state);
  }

  function minimize(state) {
    var nextState = state || 'minimized';
    setStorage(stateKey, nextState);
    syncState(nextState);
  }

  function openPopup() {
    showError('');
    syncState('open');
    setStorage(stateKey, 'open');
  }

  function showSuccess() {
    showError('');
    syncState('success');
  }

  function validateEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function ensureBackgroundSubmitFrame() {
    var existingFrame = document.querySelector('iframe[name="' + backgroundSubmitFrameName + '"]');
    if (existingFrame) return existingFrame;

    var frame = document.createElement('iframe');
    frame.name = backgroundSubmitFrameName;
    frame.hidden = true;
    frame.setAttribute('aria-hidden', 'true');
    frame.tabIndex = -1;
    document.body.appendChild(frame);
    return frame;
  }

  function submitDiscountForm(event) {
    event.preventDefault();

    var email = (emailInput.value || '').trim();
    if (!validateEmail(email)) {
      showError('Ingresa un correo valido para activar tu ' + discountLabel + '.');
      focusEmailInput();
      return;
    }

    if (getStorage(usedEmailKey) === email.toLowerCase()) {
      showError('Este correo ya uso este beneficio.');
      focusEmailInput();
      return;
    }

    if (!hasDiscountCode) {
      showError('Falta configurar el codigo de descuento en este popup.');
      return;
    }

    showError('');
    setLoading(true);
    setStorage(emailKey, email);
    setStorage(usedEmailKey, email.toLowerCase());
    setStorage(successKey, '1');
    setStorage(stateKey, 'applied');

    try {
      var submitFrame = ensureBackgroundSubmitFrame();
      form.setAttribute('target', submitFrame.name);
      form.setAttribute('action', '/contact');
      HTMLFormElement.prototype.submit.call(form);
    } catch (error) {
      // If the background newsletter submit is blocked, continue with the discount redirect.
    }

    var redirectPath = defaultRedirectPath || '/';
    var discountUrl = '/discount/' + encodeURIComponent(configuredCode) + '?redirect=' + encodeURIComponent(redirectPath);

    window.setTimeout(function () {
      window.location.assign(discountUrl);
    }, 120);
  }

  function init() {
    var rememberedEmail = getStorage(emailKey);
    if (rememberedEmail && emailInput && !emailInput.value) {
      emailInput.value = rememberedEmail;
    }

    if (getStorage(successKey) === '1') {
      window.localStorage.removeItem(successKey);
      showSuccess();
      return;
    }

    var savedState = getStorage(stateKey) || 'open';
    if (savedState !== 'minimized' && savedState !== 'applied') {
      savedState = 'open';
    }

    if (savedState === 'open') {
      window.setTimeout(function () {
        syncState('open');
      }, initialDelayMs);
      return;
    }

    syncState(savedState);
  }

  if (form) {
    form.addEventListener('submit', submitDiscountForm);
  }

  if (closeButton) {
    closeButton.addEventListener('click', function () {
      minimize('minimized');
    });
  }

  if (minimizeButton) {
    minimizeButton.addEventListener('click', function () {
      minimize('minimized');
    });
  }

  if (bubble) {
    bubble.addEventListener('click', openPopup);
  }

  if (continueButton) {
    continueButton.addEventListener('click', function () {
      minimize('applied');
    });
  }

  if (overlay) {
    overlay.addEventListener('click', function () {
      minimize('minimized');
    });
  }

  init();
})();
